jQuery( document ).ready(function($) {

  if($('.promobanner').length > 0) {

    function togglepromo(){
      $('.promobanner_text1').toggle();
      $('.promobanner_text2').toggle();
      setTimeout(togglepromo, 4000);
    }
    
    setTimeout(togglepromo, 4000);

  }
});